<!-- https://forvo.com/word/magdalene_college/#en -->

<template>
  <p>
    VIZBI 2025 will take place at the historic
    <a href="https://www.magd.cam.ac.uk/about">Magdalene College</a>&#8203;
    <Pronounced phonetically="Maudlyn" file="/2025/magdalene_college.mp3" />, located within
    <a href="https://maps.app.goo.gl/4Cf4UPPxofHPwQRKA">Cambridge city centre</a>. Magdalene is one
    of the oldest colleges of the University of Cambridge. If you're joining in-person, please read
    Magdalene's <RouterLink to="/2025/visitors-guide.pdf">Visitor Guide</RouterLink>.
  </p>
  <a href="https://www.magd.cam.ac.uk/about">
    <img src="./img/magdalene.jpg" />
  </a>
  <h4>Auditorium</h4>

  <p>
    The VIZBI sessions will be conducted at Magdelene's new, award-winning conference facility,
    <a href="https://www.magd.cam.ac.uk/conference/conferences-and-meetings">Cripps Court</a>,
    located at
    <a href="https://maps.app.goo.gl/spehWa5LbCWMJyN47">1-3 Chesterton Rd, Cambridge</a>).
  </p>
  <a href="https://www.magd.cam.ac.uk/conference/conferences-and-meetings">
    <img src="./img/auditorium.jpg" />
  </a>

  <h4>Gala Dinner</h4>
  <p>
    The gala dinner on Thursday evening will be conducted at Magdelene's
    <a href="https://www.magd.cam.ac.uk/college-life/accommodation/catering">Formal Hall</a>. This
    is an opportunity to experience a classic Cambridge University dining experience, featuring a
    candlelit setting in an historic dinning hall.
  </p>
  <a href="https://www.magd.cam.ac.uk/college-life/accommodation/catering">
    <img src="./img/formal-hall.jpg" />
  </a>

  <h4>Getting around</h4>
  <p>
    Magdalene College provides comprehensive information on
    <a href="https://www.magd.cam.ac.uk/conference/conferences-and-meetings"
    >travel and parking options</a
    >. To navigate to Cripps Court, use the following address:
    <a href="https://maps.app.goo.gl/1NpG4XTyEKs5o8tQ6">
      Magdalene College, Magdalene Street, Cambridge CB3 0AG, UK</a
    >.
  </p>
  <div class="fl-map">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2444.7287099256414!2d0.11420867710990552!3d52.21197735898841!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d870bf7c2205f7%3A0x60c7555dab9ff15a!2sCripps%20Court%20Magdalene%20College!5e0!3m2!1sen!2sau!4v1736234198231!5m2!1sen!2sau"
      aria-hidden="true"
      title="Cripps Court, Magdalene College" />
  </div>
  <div class="fl-map">
    <iframe :src="pdfFile"/>
  </div>

  <h4 id="Accommodation">Accommodation</h4>
  <p>
    Accommodation is not included in the registration fee for the VIZBI conference or Masterclass.
    We strongly recommend staying in Cambridge, close to Magdalene College. Information on nearby
    hotels and guest houses can be found
    <a href="https://www.visitcambridge.org/accommodation">here</a>.
  </p>
</template>

<script setup>
import Pronounced from "@/components/App/Pronounced.vue";
import pdfFile from "@/assets/years/2025/Venue/img/college_map.pdf";
</script>

<style scoped>
iframe {
  width: 100%;
  height: 400px;
}
div#hotels {
  columns: 3;
}
div#hotels a {
  display: block;
  margin-bottom: 8px;
}
img {
  width: 100%;
}
p.centered {
  text-align: center;
}
</style>
